module.exports = __webpack_public_path__ + "media/images/doctor-congrats_1-template-7e0220f8752572a8a60674f7e2e6e9ad.jpg";